@if (user) {
  <div class="user-description">
    <div class="user-description-header">
      <app-avatar
        class="user-avatar"
        [image]="user.avatar_url"
        [name]="user.username"
        [countryCode]="user.country?.code">
      </app-avatar>
      <div class="user-username">{{ user.username }}</div>
    </div>
    <div class="user-description-content">
      <div class="user-description-body" [innerHTML]="user.description"></div>
    </div>
  </div>
}
